(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("styled-components"), require("icepath"), require("startlibs/lib/lib"), require("startlibs/lib/hocs"), require("polished"), require("startlibs"), require("react-redux"), require("react-dom"), require("startlibs/lib/components"), require("reselect"));
	else if(typeof define === 'function' && define.amd)
		define("statlibs", ["react", "styled-components", "icepath", "startlibs/lib/lib", "startlibs/lib/hocs", "polished", "startlibs", "react-redux", "react-dom", "startlibs/lib/components", "reselect"], factory);
	else if(typeof exports === 'object')
		exports["statlibs"] = factory(require("react"), require("styled-components"), require("icepath"), require("startlibs/lib/lib"), require("startlibs/lib/hocs"), require("polished"), require("startlibs"), require("react-redux"), require("react-dom"), require("startlibs/lib/components"), require("reselect"));
	else
		root["statlibs"] = factory(root["react"], root["styled-components"], root["icepath"], root["startlibs/lib/lib"], root["startlibs/lib/hocs"], root["polished"], root["startlibs"], root["react-redux"], root["react-dom"], root["startlibs/lib/components"], root["reselect"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_10__, __WEBPACK_EXTERNAL_MODULE_11__, __WEBPACK_EXTERNAL_MODULE_18__, __WEBPACK_EXTERNAL_MODULE_20__, __WEBPACK_EXTERNAL_MODULE_49__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 47);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLEAR_ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REMOVE_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AJAX_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return setAjaxDefaultError; });
/* harmony export (immutable) */ __webpack_exports__["f"] = makeActionCreator;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return reducerCreator; });
/* unused harmony export arrToMap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_icepath__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_icepath___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_icepath__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var SET_ERRORS = 'SET_ERRORS';
var CLEAR_ERRORS = 'CLEAR_ERRORS';
var REMOVE_LOADING = 'REMOVE_LOADING';
var ADD_LOADING = 'ADD_LOADING';
var AJAX_ERROR = '';
var setAjaxDefaultError = function setAjaxDefaultError(s) {
  return AJAX_ERROR = s;
};

function makeActionCreator(key, reducer, fetcher) {
  var fn = function fn(possiblePayload, possibleActionMeta) {
    return function (dispatch, getState) {
      var payload = (typeof possiblePayload === 'undefined' ? 'undefined' : _typeof(possiblePayload)) !== 'object' || Array.isArray(possiblePayload) || possiblePayload.constructor === Object ? possiblePayload : {};
      var actionMeta = (typeof possibleActionMeta === 'undefined' ? 'undefined' : _typeof(possibleActionMeta)) === 'object' && possibleActionMeta.constructor === Object ? possibleActionMeta : {};
      var meta = _extends({
        _origin: key,
        _payload: payload
      }, actionMeta, {
        actionId: (actionMeta ? actionMeta.actionId : '') || ''
      });
      if (fetcher && !meta._dontFetch) {
        dispatch({ type: CLEAR_ERRORS, payload: meta.actionKey || key + meta.actionId, meta: meta });
        dispatch({ type: ADD_LOADING, meta: meta });
        var fetched = fetcher(payload, actionMeta).then(function (response) {
          if (response.errors) {
            throw response;
          } else {
            dispatch({
              type: key,
              payload: response.success || response,
              meta: _extends({}, meta, response)
            });
          }
          return { success: response.success || response, meta: meta };
        }).catch(function (e) {
          if (e.errors) {
            dispatch({ type: SET_ERRORS, payload: e.errors, meta: meta });
            return { errors: e.errors, meta: meta };
          } else if (e.errorResponse) {
            return { errors: true, response: e.errorResponse, meta: meta };
          } else {
            console.log(e);
            dispatch({ type: SET_ERRORS, payload: { _connection_error_: [AJAX_ERROR] }, meta: _extends({}, meta, { _errorType: e.name }) });
            return { errors: e, meta: meta };
          }
        });
        fetched.then(function (v) {
          return dispatch({ type: REMOVE_LOADING, payload: v, meta: meta });
        });
        return fetched;
      } else {
        dispatch({ type: key, payload: payload, meta: meta });
        return Promise.resolve({ success: payload, meta: meta });
      }
    };
  };
  var actionCreator = fn;
  actionCreator.toString = function () {
    return key;
  };
  actionCreator.reducer = reducer;
  return actionCreator;
}

var reducerCreator = function reducerCreator(initialState, actions) {
  var reducer = actions.reduce(function (acc, action) {
    return _extends({}, acc, _defineProperty({}, action, action.reducer));
  }, {});
  return function (extraReducers) {
    var finalReducer = _extends({}, reducer, extraReducers);
    return function (state, action) {
      return finalReducer[action.type] ? finalReducer[action.type](__WEBPACK_IMPORTED_MODULE_0_icepath__["ice"].chain(state), action.payload, action.meta).value() : state || initialState;
    };
  };
};

function arrToMap(arr) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';

  var map = {};
  for (var i = 0; i < arr.length; i++) {
    map[arr[i][key]] = arr[i];
  }
  return map;
}

/***/ }),
/* 7 */,
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getMargin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return customTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ifProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return media; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_icepath__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_icepath___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_icepath__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_polished__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_polished___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_polished__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_styled_components__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n    @media screen and (max-width: 600px) {\n      ', '\n    }\n  '], ['\n    @media screen and (max-width: 600px) {\n      ', '\n    }\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    @media screen and (min-width: 601px) {\n      ', '\n    }\n  '], ['\n    @media screen and (min-width: 601px) {\n      ', '\n    }\n  ']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var getColor = function getColor(propsOrColor, hover) {
  if (typeof propsOrColor === 'string') {
    return function (_ref) {
      var theme = _ref.theme;
      return theme.colors[propsOrColor];
    };
  }

  var theme = propsOrColor.theme,
      props = _objectWithoutProperties(propsOrColor, ['theme']);

  if (props.dark) {
    return __WEBPACK_IMPORTED_MODULE_1_polished__["darken"](0.1, getColor(_extends({ theme: theme }, __WEBPACK_IMPORTED_MODULE_0_icepath__["ice"].unset(props, 'dark'))));
  } else if (hover && props.hover) {
    return getColor({ theme: theme, color: props.hover });
  } else if (props.color) {
    return theme.colors[props.color] || props.color;
  } else if (props.highlight) {
    return theme.colors.main;
  } else if (props.alert) {
    return theme.colors.alert;
  } else if (props.success) {
    return theme.colors.success;
  } else {
    return theme.colors.gray150;
  }
};


var getMargin = function getMargin(enumeratedMargins) {
  return function (props) {
    return enumeratedMargins[props.margin] || props.margin || enumeratedMargins['default'] || 0;
  };
};

/**
 * Returns the value of `props[path]` or `defaultValue`
 * @example
 * const Button = styled.button`
 *  color: ${prop('color', 'red')};
 * `
 */
var getProp = function getProp(path, defaultValue) {
  return function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return __WEBPACK_IMPORTED_MODULE_0_icepath__["ice"].get(props, [].concat(path)) || defaultValue;
  };
};

var customTheme = function customTheme(type) {
  return function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return __WEBPACK_IMPORTED_MODULE_0_icepath__["ice"].get(props, ["theme", "startlibs", type]) || '';
  };
};

/**
 * Returns `pass` if prop is truthy. Otherwise returns `fail`
 * @example
 * // usage with styled-theme
 * import styled from 'styled-components'
 * import { ifProp } from 'styled-tools'
 * import { palette } from 'styled-theme'
 *
 * const Button = styled.button`
 *  background-color: ${ifProp('transparent', 'transparent', palette(0))};
 *  color: ${ifProp(['transparent', 'accent'], palette('secondary', 0))};
 *  font-size: ${ifProp({ size: 'large' }, '20px', ifProp({ size: 'medium' }, '16px', '12px'))};
 *`
 */
var ifProp = function ifProp(path, pass, fail) {
  return function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var result = false;
    if (Array.isArray(path)) {
      result = path.every(function (p) {
        return testSinglePath(props, p);
      });
    } else if ((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object') {
      result = !Object.entries(path).find(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            k = _ref3[0],
            v = _ref3[1];

        return props[k] !== v;
      });
    } else {
      result = testSinglePath(props, path);
    }
    return result ? pass : fail;
  };
};

var media = {
  mobile: function mobile() {
    return __WEBPACK_IMPORTED_MODULE_2_styled_components__["css"](_templateObject, __WEBPACK_IMPORTED_MODULE_2_styled_components__["css"].apply(undefined, arguments));
  },
  desktop: function desktop() {
    return __WEBPACK_IMPORTED_MODULE_2_styled_components__["css"](_templateObject2, __WEBPACK_IMPORTED_MODULE_2_styled_components__["css"].apply(undefined, arguments));
  }
};

function testSinglePath(props, path) {
  if (typeof path === 'string') {
    return !!__WEBPACK_IMPORTED_MODULE_0_icepath__["ice"].get(props, path);
  } else if (typeof path === 'number') {
    return !!props[path];
  } else {
    return false;
  }
}

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Icon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_styled_components__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class;

var _templateObject = _taggedTemplateLiteral(['\n  font-family: \'', '\' !important;\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  \n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  user-select: none; \n  ', '\n'], ['\n  font-family: \'', '\' !important;\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  \n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  user-select: none; \n  ', '\n']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var IconComponent = __WEBPACK_IMPORTED_MODULE_1_styled_components__["withTheme"](_class = function (_React$Component) {
  _inherits(IconComponent, _React$Component);

  function IconComponent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, IconComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = IconComponent.__proto__ || Object.getPrototypeOf(IconComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(IconComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var icon = this.props.icon;
      if ((this.props.theme.svgIcons || {})[icon]) {
        this.props.theme.svgLoader(icon).then(function (i) {
          return _this2.setState({ Svg: i.default });
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          icon = _props.icon,
          children = _props.children,
          withImageHeader = _props.withImageHeader,
          theme = _props.theme,
          clickable = _props.clickable,
          customIcon = _props.customIcon,
          colorSet = _props.colorSet,
          color = _props.color,
          rest = _objectWithoutProperties(_props, ['icon', 'children', 'withImageHeader', 'theme', 'clickable', 'customIcon', 'colorSet', 'color']);

      if ((theme.svgIcons || {})[icon]) {
        if (this.state.Svg) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(this.state.Svg, rest);
        } else {
          return null;
        }
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        rest,
        theme.icons[icon] || customIcon && icon,
        children
      );
    }
  }]);

  return IconComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component)) || _class;

var Icon = __WEBPACK_IMPORTED_MODULE_1_styled_components___default.a(IconComponent)(_templateObject, function (props) {
  return props.theme.iconFont;
}, function (props) {
  return props.clickable && '\n    cursor: pointer;\n    &:hover {\n      opacity: 0.85;\n    }\n  ';
});

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_10__;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_11__;

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return enhancedInputDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return enhanceInput; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_icepath__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_icepath___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_icepath__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var enhancedInputDisplayName = 'EnhancedInput';

var undefinedToDefault = function undefinedToDefault(v, defaultValue) {
  return v === undefined ? defaultValue : v;
};

var enhanceInput = function enhanceInput(InputComponent) {
  var EnhancedInput = function (_React$Component) {
    _inherits(EnhancedInput, _React$Component);

    function EnhancedInput() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, EnhancedInput);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EnhancedInput.__proto__ || Object.getPrototypeOf(EnhancedInput)).call.apply(_ref, [this].concat(args))), _this), _this.path = function () {
        return __WEBPACK_IMPORTED_MODULE_1_icepath__["ice"].toPath(_this.props.path);
      }, _this.getValue = function () {
        return undefinedToDefault(_this.props.value || (_this.props.form ? __WEBPACK_IMPORTED_MODULE_1_icepath__["ice"].get(_this.props.form.properties, _this.path()) : undefined), _this.props.defaultValue);
      }, _this.setErrors = function (errorList) {
        return _this.props.form.connector.setErrors(_defineProperty({}, _this.props.path.join('.'), errorList));
      }, _this.clearErrors = function () {
        return _this.props.form.connector.setErrors([_this.props.path.join('.')]);
      }, _this.setValueFromEventTarget = function (e) {
        return _this.setValue(e.currentTarget.value);
      }, _this.setValue = function (value, element) {
        var path = _this.path();
        _this.props.setValue ? _this.props.setValue(value, path, function (value) {
          return _this.props.form.connector.setValue(path, value);
        }, element) : _this.props.form.connector.setValue(path, value);
        _this.props.onChange && _this.props.onChange(value, path, element);
      }, _this.setFromField = function () {
        return _this.setValue(_this.props.fieldValue);
      }, _this.toggle = function () {
        return _this.setValue(!_this.getValue());
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(EnhancedInput, [{
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _props = this.props,
            children = _props.children,
            form = _props.form,
            path = _props.path,
            defaultValue = _props.defaultValue,
            setInnerRef = _props.setInnerRef,
            rest = _objectWithoutProperties(_props, ['children', 'form', 'path', 'defaultValue', 'setInnerRef']);

        var value = this.getValue();
        var rootPath = form ? [].concat(form.meta.errorRootPath || []) : [];
        var errors = form ? Object.keys(form.errors).filter(function (key) {
          return rootPath.concat(_this2.path(), '.').join('.').indexOf(key + '.') === 0;
        }) : [];
        var hasErrors = this.props.hasErrors || (errors.length ? errors : false);
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          InputComponent,
          _extends({}, rest, {
            value: value,
            hasErrors: hasErrors,
            setErrors: this.setErrors,
            clearErrors: this.clearErrors,
            name: this.path().join('.'),
            setValue: this.setValue,
            setFromField: this.setFromField,
            toggle: this.toggle,
            ref: setInnerRef,
            setValueFromEventTarget: this.setValueFromEventTarget }),
          children
        );
      }
    }]);

    return EnhancedInput;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

  EnhancedInput.displayName = enhancedInputDisplayName;
  return EnhancedInput;
};


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fieldMargins; });
/* unused harmony export FieldDescription */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Field; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_styled_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _templateObject = _taggedTemplateLiteral(['\n  color: #c3282d;\n  margin-left: 1px;\n  vertical-align: top;\n  line-height: 100%;\n  margin-top: -1px;\n  ', '\n'], ['\n  color: #c3282d;\n  margin-left: 1px;\n  vertical-align: top;\n  line-height: 100%;\n  margin-top: -1px;\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  position: relative;\n  margin-bottom: ', ';\n'], ['\n  position: relative;\n  margin-bottom: ', ';\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  font-weight: 500;\n  display: inline-block;\n  font-size: 14px;\n  margin-bottom: .5rem;\n  ', '\n  ', '\n'], ['\n  font-weight: 500;\n  display: inline-block;\n  font-size: 14px;\n  margin-bottom: .5rem;\n  ', '\n  ', '\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  color: ', ';\n  font-size: 13px;\n  font-weight: 400;\n'], ['\n  color: ', ';\n  font-size: 13px;\n  font-weight: 400;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  color: rgba(0,0,0,0.4);\n  display: block;\n  font-size: 12px;\n  margin: 0.25rem 0;\n  font-weight: 400;\n'], ['\n  color: rgba(0,0,0,0.4);\n  display: block;\n  font-size: 12px;\n  margin: 0.25rem 0;\n  font-weight: 400;\n']);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }





var fieldMargins = { none: '0', big: '2rem', 'default': '1rem' };

var Mandatory = __WEBPACK_IMPORTED_MODULE_0_styled_components___default.a.span(_templateObject, function (props) {
  return typeof props.mandatory === 'string' && 'color: ' + props.mandatory + ';';
});
var Container = __WEBPACK_IMPORTED_MODULE_0_styled_components___default.a.div(_templateObject2, __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["getMargin"](fieldMargins));
var Label = __WEBPACK_IMPORTED_MODULE_0_styled_components___default.a.label(_templateObject3, function (props) {
  return props.onImage && 'color: #fff;';
}, __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["customTheme"]("FieldLabel"));

var HelpText = __WEBPACK_IMPORTED_MODULE_0_styled_components___default.a.span(_templateObject4, __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_lib__["getColor"]('gray120'));
var FieldDescription = __WEBPACK_IMPORTED_MODULE_0_styled_components___default.a.span(_templateObject5);

var Field = (_temp = _class = function (_React$Component) {
  _inherits(Field, _React$Component);

  function Field() {
    _classCallCheck(this, Field);

    return _possibleConstructorReturn(this, (Field.__proto__ || Object.getPrototypeOf(Field)).apply(this, arguments));
  }

  _createClass(Field, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          label = _props.label,
          children = _props.children,
          focused = _props.focused,
          mandatory = _props.mandatory,
          descText = _props.descText,
          helpText = _props.helpText,
          labelClick = _props.labelClick,
          className = _props.className,
          rest = _objectWithoutProperties(_props, ['label', 'children', 'focused', 'mandatory', 'descText', 'helpText', 'labelClick', 'className']);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        Container,
        _extends({}, rest, { className: className }),
        label && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          Label,
          _extends({}, rest, { onClick: labelClick }),
          label,
          mandatory && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            Mandatory,
            { mandatory: mandatory },
            '*'
          ),
          helpText && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            HelpText,
            null,
            ' ',
            helpText
          ),
          descText && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            FieldDescription,
            null,
            descText
          )
        ),
        children
      );
    }
  }]);

  return Field;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.Label = Label, _class.Container = Container, _class.HelpText = HelpText, _class.Description = FieldDescription, _class.displayName = "Field", _temp);

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_18__;

/***/ }),
/* 19 */,
/* 20 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_20__;

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Errors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_startlibs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_styled_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Icon__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_polished__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_polished___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_polished__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_reselect__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_startlibs_lib_lib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_startlibs_lib_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_startlibs_lib_lib__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp2;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _templateObject = _taggedTemplateLiteral(['\n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n  '], ['\n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    background-color: ', ';\n    padding: 1rem 3.5rem 1rem 1rem;\n    border-radius: 4px;\n    border: 1px solid ', ';\n    color: ', ';\n    margin-top: 1rem;\n    position:relative;\n    & ~ & {\n      margin-top: 0.5rem;\n    }\n    ', '\n  '], ['\n    background-color: ', ';\n    padding: 1rem 3.5rem 1rem 1rem;\n    border-radius: 4px;\n    border: 1px solid ', ';\n    color: ', ';\n    margin-top: 1rem;\n    position:relative;\n    & ~ & {\n      margin-top: 0.5rem;\n    }\n    ', '\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    color: ', ';\n    font-weight: 600;\n    display: inline-block;\n    background-color: ', ';\n    width: 21px;\n    height: 21px;\n    line-height: 21px;\n    text-align: center;\n    border-radius: 50%;\n    cursor: pointer;\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    z-index: 2;\n    &:hover {\n      background-color: ', ';\n    }\n  '], ['\n    color: ', ';\n    font-weight: 600;\n    display: inline-block;\n    background-color: ', ';\n    width: 21px;\n    height: 21px;\n    line-height: 21px;\n    text-align: center;\n    border-radius: 50%;\n    cursor: pointer;\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    z-index: 2;\n    &:hover {\n      background-color: ', ';\n    }\n  ']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var emptyList = [];
var identityFn = function identityFn(e) {
  return e;
};
var identityFn2 = function identityFn2(_, e) {
  return e;
};
var identityFn3 = function identityFn3(_, _2, e) {
  return e;
};

var errorSelector = function errorSelector() {
  return __WEBPACK_IMPORTED_MODULE_6_reselect__["createSelector"]([identityFn, identityFn2, identityFn3], function (propsErrors, form, pathProp) {
    var rootPath = form ? [].concat(form.meta.errorRootPath || emptyList) : emptyList;
    var path = rootPath.concat(pathProp).join('.');

    var allErrors = propsErrors.concat(form ? [{
      action: form.connector.getActionKey(),
      errors: form.errors
    }] : []);
    var result = {};
    allErrors.forEach(function (_ref) {
      var action = _ref.action,
          errors = _ref.errors;

      Object.entries(errors).filter(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 1),
            key = _ref3[0];

        return key.indexOf(path) === 0;
      }).forEach(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
            key = _ref5[0],
            errorList = _ref5[1];

        errorList.filter(function (value) {
          return value && value[0] !== '$';
        }).forEach(function (value) {
          result[value] = (result[value] || []).concat({ action: action, key: key, value: value });
        });
      });
    });
    return Object.values(result);
  });
};

var Errors = (_dec = __WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"](function (state, _ref6) {
  var actions = _ref6.actions;
  return { // todo mudar pra actions
    propsErrors: actions ? (typeof actions === 'string' ? [actions] : actions).map(function (action) {
      return {
        action: action,
        errors: state.errors[action]
      };
    }) : emptyList
  };
}, function (dispatch) {
  return {
    remove: function remove(actionKey, key, value) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_2_startlibs__["removeError"](actionKey, { key: key, value: value }));
    }
  };
}), _dec(_class = (_temp2 = _class2 = function (_React$PureComponent) {
  _inherits(Errors, _React$PureComponent);

  function Errors() {
    var _ref7;

    var _temp, _this, _ret;

    _classCallCheck(this, Errors);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref7 = Errors.__proto__ || Object.getPrototypeOf(Errors)).call.apply(_ref7, [this].concat(args))), _this), _this.remove = function (errors) {
      return function () {
        errors.forEach(function (_ref8) {
          var action = _ref8.action,
              key = _ref8.key,
              value = _ref8.value;
          return _this.props.remove(action, [key], value);
        });
      };
    }, _this.selector = errorSelector(), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Errors, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          form = _props.form,
          propsErrors = _props.propsErrors,
          errors = _props.errors,
          className = _props.className;

      var errorsList = this.selector(propsErrors, form, this.props.path).concat(errors || []);
      if (errorsList.length) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          Errors.Container,
          { className: className },
          errorsList.map(function (error) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              Errors.Item,
              { key: error[0].value },
              error[0].value,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Errors.CloseIcon, { onClick: error[0].remove || _this2.remove(error) })
            );
          })
        );
      } else return null;
    }
  }]);

  return Errors;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent), _class2.displayName = "Errors", _class2.Container = __WEBPACK_IMPORTED_MODULE_3_styled_components___default.a.ul(_templateObject), _class2.Item = __WEBPACK_IMPORTED_MODULE_3_styled_components___default.a.li(_templateObject2, function (props) {
  return __WEBPACK_IMPORTED_MODULE_5_polished__["lighten"](0.42, props.theme.colors.alert);
}, function (props) {
  return __WEBPACK_IMPORTED_MODULE_5_polished__["lighten"](0.35, props.theme.colors.alert);
}, __WEBPACK_IMPORTED_MODULE_7_startlibs_lib_lib__["getColor"]('alert'), __WEBPACK_IMPORTED_MODULE_7_startlibs_lib_lib__["customTheme"]("ErrorItem")), _class2.CloseIcon = __WEBPACK_IMPORTED_MODULE_3_styled_components___default.a(__WEBPACK_IMPORTED_MODULE_4__Icon__["a" /* Icon */]).attrs({ icon: 'x' })(_templateObject3, __WEBPACK_IMPORTED_MODULE_7_startlibs_lib_lib__["getColor"]('alert'), function (props) {
  return __WEBPACK_IMPORTED_MODULE_5_polished__["lighten"](0.35, props.theme.colors.alert);
}, function (props) {
  return __WEBPACK_IMPORTED_MODULE_5_polished__["lighten"](0.32, props.theme.colors.alert);
}), _temp2)) || _class);

/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_form_Form__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_form_enhanceInput__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_form_Field__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_form_Errors__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_form_TextInput__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_form_withFormImageInput__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_form_SimpleCheckbox__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_form_SimpleRadiobox__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_form_Combobox__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_form_IconRadioBox__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_form_AutoComplete__ = __webpack_require__(56);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AutoComplete", function() { return __WEBPACK_IMPORTED_MODULE_10__components_form_AutoComplete__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Form", function() { return __WEBPACK_IMPORTED_MODULE_0__components_form_Form__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Errors", function() { return __WEBPACK_IMPORTED_MODULE_3__components_form_Errors__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withFormImageInput", function() { return __WEBPACK_IMPORTED_MODULE_5__components_form_withFormImageInput__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FileInput", function() { return __WEBPACK_IMPORTED_MODULE_5__components_form_withFormImageInput__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TextInput", function() { return __WEBPACK_IMPORTED_MODULE_4__components_form_TextInput__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FloatLabelTextInput", function() { return __WEBPACK_IMPORTED_MODULE_4__components_form_TextInput__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withForm", function() { return __WEBPACK_IMPORTED_MODULE_0__components_form_Form__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Field", function() { return __WEBPACK_IMPORTED_MODULE_2__components_form_Field__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "enhanceInput", function() { return __WEBPACK_IMPORTED_MODULE_1__components_form_enhanceInput__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "enhancedInputDisplayName", function() { return __WEBPACK_IMPORTED_MODULE_1__components_form_enhanceInput__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SimpleRadiobox", function() { return __WEBPACK_IMPORTED_MODULE_7__components_form_SimpleRadiobox__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SimpleCheckbox", function() { return __WEBPACK_IMPORTED_MODULE_6__components_form_SimpleCheckbox__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Combobox", function() { return __WEBPACK_IMPORTED_MODULE_8__components_form_Combobox__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IconRadioBox", function() { return __WEBPACK_IMPORTED_MODULE_9__components_form_IconRadioBox__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StyledIconRadioBox", function() { return __WEBPACK_IMPORTED_MODULE_9__components_form_IconRadioBox__["b"]; });














/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return withForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Form; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_startlibs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_icepath__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_icepath___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_icepath__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_hocs__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_hocs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_startlibs_lib_hocs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_components__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_startlibs_lib_components__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var emptyErrors = {};
var identityValidation = function identityValidation(props, meta) {
  return { success: props, meta: meta };
};

var uid = 1;
var getNextUid = function getNextUid() {
  return 'uid:' + uid++;
};

var withForm = function withForm(hocAction) {
  var useUniqueId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return function (Component) {
    var _dec, _dec2, _class, _class2, _temp, _initialiseProps;

    var getKey = function getKey(ownProps) {
      return String(ownProps.actionKey || '') || String(ownProps.action || hocAction || 'noaction?') + String(ownProps.actionId || '');
    };

    var WithForm = (_dec = __WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"](function (state, ownProps) {
      return {
        errors: state.appUI.errors[getKey(ownProps)] || emptyErrors,
        isLoading: state.appUI.loadings[getKey(ownProps)] || false
      };
    }, function (dispatch, ownProps) {
      return {
        clearErrors: function clearErrors(path) {
          return dispatch(__WEBPACK_IMPORTED_MODULE_2_startlibs__["clearErrors"](getKey(ownProps), { path: path }));
        },
        setErrors: function setErrors(errors) {
          return dispatch(__WEBPACK_IMPORTED_MODULE_2_startlibs__["setErrors"](errors, { actionKey: getKey(ownProps) }));
        },
        dispatchAction: function dispatchAction(action, props, meta) {
          return dispatch(action(props, _extends({
            actionKey: ownProps.actionKey,
            actionId: ownProps.actionId }, meta)));
        },
        addLoading: function addLoading(meta) {
          return dispatch(__WEBPACK_IMPORTED_MODULE_2_startlibs__["addLoading"]({}, meta));
        },
        removeLoading: function removeLoading(meta) {
          return dispatch(__WEBPACK_IMPORTED_MODULE_2_startlibs__["removeLoading"]({}, meta));
        }
      };
    }), _dec2 = __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_hocs__["withToggles"]('confirmCloseDialog'), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
      _inherits(WithForm, _React$Component);

      function WithForm(props) {
        _classCallCheck(this, WithForm);

        var _this = _possibleConstructorReturn(this, (WithForm.__proto__ || Object.getPrototypeOf(WithForm)).call(this, props));

        _initialiseProps.call(_this);

        _this.defaultedProps = props.formProperties === undefined;
        _this.state = {
          formProperties: !_this.defaultedProps ? props.formProperties : {},
          hasChanged: false,
          willSubmitForm: false,
          meta: props.meta
        };
        _this.preValidation = identityValidation;
        _this.connector = {
          setValue: function setValue(path, value) {
            var hasChanged = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

            if (_this.state.formProperties) _this.setState(function (prevState) {
              return {
                formProperties: __WEBPACK_IMPORTED_MODULE_3_icepath__["ice"].set(prevState.formProperties, path, value),
                willSubmitForm: hasChanged ? false : prevState.willSubmitForm,
                hasChanged: prevState.hasChanged || hasChanged
              };
            });
          },
          setValues: function setValues(valuesSetter) {
            var hasChanged = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            if (_this.state.formProperties) _this.setState(function (prevState) {
              return {
                formProperties: valuesSetter(__WEBPACK_IMPORTED_MODULE_3_icepath__["ice"].chain(prevState.formProperties)).value(),
                willSubmitForm: hasChanged ? false : prevState.willSubmitForm,
                hasChanged: prevState.hasChanged || hasChanged
              };
            });
          },
          resetForm: function resetForm() {
            return _this.setState({ formProperties: _this.props.formProperties, hasChanged: false });
          },
          resetField: function resetField(path) {
            return _this.setState({ formProperties: __WEBPACK_IMPORTED_MODULE_3_icepath__["ice"].set(_this.state.formProperties, path, __WEBPACK_IMPORTED_MODULE_3_icepath__["ice"].get(_this.props.formProperties, path)) });
          },
          getOriginalProps: function getOriginalProps() {
            return _this.props.formProperties;
          },
          getFormProperties: function getFormProperties() {
            return _this.state.formProperties;
          },
          setHasChanged: function setHasChanged(hasChanged) {
            return _this.setState({ hasChanged: hasChanged });
          },
          setMeta: function setMeta(metaSetter) {
            return _this.setState(function (state) {
              return { meta: metaSetter(__WEBPACK_IMPORTED_MODULE_3_icepath__["ice"].chain(state.meta)).value() };
            });
          },
          getProperty: function getProperty(path) {
            return __WEBPACK_IMPORTED_MODULE_3_icepath__["ice"].get(_this.state.formProperties, path);
          },
          getAction: function getAction() {
            return _this.props.action;
          },
          getActionKey: function getActionKey() {
            return getKey(_this.props);
          },
          setErrors: props.setErrors,
          getErrors: function getErrors() {
            return _this.props.errors;
          },
          hasErrors: function hasErrors() {
            return Object.keys(_this.props.errors).length > 0;
          },
          clearErrors: props.clearErrors,
          submitProperties: _this.submitProperties,
          validate: function validate(props, meta) {
            return !(_this.validate(props, meta) || {}).errors;
          },
          toggleConfirmCloseDialog: props.confirmCloseDialog.toggle,
          handleSubmit: _this.handleSubmit,
          setForm: _this.setForm
        };
        return _this;
      }

      _createClass(WithForm, [{
        key: 'cacheNewForm',
        value: function cacheNewForm(newForm) {
          if (!this.lastForm || this.lastForm.errors !== newForm.errors || this.lastForm.meta !== newForm.meta || this.lastForm.properties !== newForm.properties || this.lastForm.isLoading !== newForm.isLoading || this.lastForm.hasChanged !== newForm.hasChanged) return this.lastForm = newForm;else return this.lastForm;
        }
      }, {
        key: 'render',
        value: function render() {
          var _props = this.props,
              action = _props.action,
              errors = _props.errors,
              confirmCloseDialog = _props.confirmCloseDialog,
              isLoading = _props.isLoading,
              rest = _objectWithoutProperties(_props, ['action', 'errors', 'confirmCloseDialog', 'isLoading']);

          var willSubmitForm = this.state.willSubmitForm;

          var cachedForm = this.cacheNewForm({
            errors: errors,
            action: action,
            meta: this.state.meta,
            properties: this.state.formProperties,
            connector: this.connector,
            hasChanged: this.state.hasChanged,
            isLoading: isLoading || willSubmitForm
          });
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            Component,
            _extends({}, rest, {
              isLoading: isLoading || willSubmitForm,
              handleSubmitForm: this.handleSubmit,
              form: cachedForm,
              hasChanged: this.state.hasChanged
            }),
            this.props.children,
            confirmCloseDialog.isOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_startlibs_lib_components__["DefaultConfirmDialog"], {
              onCancel: confirmCloseDialog.toggle,
              onConfirm: this.props.closeDialog,
              onSaveInstead: this.handleSubmit
            })
          );
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
          if (prevState.willSubmitForm && !this.state.willSubmitForm) {
            this.props.clearErrors(['_willSubmitForm']);
          }
          if (prevState.meta.submittingImage !== 0 && this.state.meta.submittingImage === 0) {
            if (this.submittingForm) {
              if (this.state.willSubmitForm) this.submittingForm.confirm();else this.submittingForm.cancel();
            }
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          this.props.clearErrors();
        }
      }]);

      return WithForm;
    }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class2.contextTypes = { startlibs: function startlibs() {
        return null;
      } }, _class2.defaultProps = {
      action: hocAction,
      meta: {}
    }, _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.setForm = function (props) {
        _this2.preValidation = props.preValidation || identityValidation;
        _this2.onSuccess = props.onSuccess;
        _this2.onFailure = props.onFailure;
        _this2.handleFormSubmit = props.handleSubmit;
        if (props.defaultProperties && _this2.defaultedProps) {
          _this2.defaultedProps = false;
          _this2.setState({ formProperties: props.defaultProperties });
        }
      };

      this.validate = function (properties, meta) {
        var completeMeta = _extends({}, _this2.state.meta, meta);
        var validated = _this2.preValidation(properties || _this2.state.formProperties, completeMeta);
        if (validated.errors) {
          _this2.props.setErrors(validated.errors);
          _this2.props.confirmCloseDialog.close();
          return _extends({}, validated, { meta: validated.meta || completeMeta });
        }
        return validated ? _extends({}, validated, { meta: validated.meta || completeMeta }) : validated;
      };

      this.submitProperties = function (properties, meta) {
        if (_this2.props.isLoading) {
          return new Promise(function () {});
        }
        if (_this2.state.meta.submittingImage) {
          _this2.props.setErrors({ '_willSubmitForm': [_this2.context.startlibs.FormUploadingImageError] });
          _this2.props.confirmCloseDialog.close();
          _this2.setState({ willSubmitForm: true });
          return new Promise(function (resolve, reject) {
            _this2.submittingForm = {
              confirm: function confirm() {
                return resolve(_this2.submitProperties(properties, meta));
              },
              cancel: function cancel() {
                return resolve({ errors: {} });
              }
            };
          });
        }

        var original = _this2.props.formProperties;
        var dispatchAction = _this2.props.dispatchAction;

        var validated = _this2.validate(properties, meta);
        if (!validated) {
          return Promise.resolve({});
        } else if (validated.errors) {
          return Promise.resolve(validated);
        } else {
          if (!_this2.props.alwaysSave && !validated.meta.alwaysSave && !_this2.state.hasChanged && (!properties || properties === _this2.state.formProperties)) {
            _this2.onSuccess && _this2.onSuccess(validated, {}, {}, original);
            _this2.props.onSuccess && _this2.props.onSuccess(validated, {}, {}, original);
            return Promise.resolve({ validated: validated });
          }
          // add loading to custom submit
          _this2.handleFormSubmit && _this2.props.addLoading({ actionKey: getKey(_this2.props) });
          var fetched = _this2.handleFormSubmit ? _this2.handleFormSubmit(validated.success, validated.meta) : dispatchAction(_this2.props.action || hocAction, validated.success, validated.meta);
          fetched.then(function (_ref) {
            var success = _ref.success,
                errors = _ref.errors,
                meta = _ref.meta,
                response = _ref.response;

            // remove loading from custom submit
            _this2.handleFormSubmit && _this2.props.removeLoading({ actionKey: getKey(_this2.props) });
            if (!errors) {
              _this2.setState({ hasChanged: false }, function () {
                _this2.onSuccess && _this2.onSuccess(validated, success, meta, original);
                _this2.props.onSuccess && _this2.props.onSuccess(validated, success, meta, original);
              });
            }
            if (errors) {
              var errorsObj = (typeof errors === 'undefined' ? 'undefined' : _typeof(errors)) === 'object' ? errors : { errors: errors, response: response };
              _this2.props.confirmCloseDialog.close();
              _this2.onFailure && _this2.onFailure(validated, errorsObj, meta, original);
              _this2.props.onFailure && _this2.props.onFailure(validated, errorsObj, meta, original);
            }
          });
          return fetched.then(function (result) {
            return _extends({}, result, { validated: validated, original: original });
          });
        }
      };

      this.handleSubmit = function (e) {
        if (e) e.preventDefault();
        return _this2.submitProperties();
      };
    }, _temp)) || _class) || _class);

    var FormWithUID = function (_React$Component2) {
      _inherits(FormWithUID, _React$Component2);

      function FormWithUID() {
        var _ref2;

        var _temp2, _this3, _ret;

        _classCallCheck(this, FormWithUID);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp2 = (_this3 = _possibleConstructorReturn(this, (_ref2 = FormWithUID.__proto__ || Object.getPrototypeOf(FormWithUID)).call.apply(_ref2, [this].concat(args))), _this3), _this3.uid = getNextUid(), _temp2), _possibleConstructorReturn(_this3, _ret);
      }

      _createClass(FormWithUID, [{
        key: 'render',
        value: function render() {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WithForm, _extends({}, this.props, {
            actionId: this.props.actionId !== undefined || !useUniqueId ? this.props.actionId : this.uid }));
        }
      }]);

      return FormWithUID;
    }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

    return FormWithUID;
  };
};


var Form = function (_React$Component3) {
  _inherits(Form, _React$Component3);

  function Form() {
    var _ref3;

    var _temp3, _this4, _ret2;

    _classCallCheck(this, Form);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp3 = (_this4 = _possibleConstructorReturn(this, (_ref3 = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref3, [this].concat(args))), _this4), _this4.firstTime = true, _this4.submit = function (e) {
      e.preventDefault();
      _this4.props.form.connector.submitProperties();
    }, _temp3), _possibleConstructorReturn(_this4, _ret2);
  }

  _createClass(Form, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.componentWillReceiveProps(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      var _this5 = this;

      var form = newProps.form,
          className = newProps.className,
          children = newProps.children,
          preValidation = newProps.preValidation,
          onSuccess = newProps.onSuccess,
          onFailure = newProps.onFailure,
          handleSubmit = newProps.handleSubmit,
          meta = _objectWithoutProperties(newProps, ['form', 'className', 'children', 'preValidation', 'onSuccess', 'onFailure', 'handleSubmit']);

      form.connector.setForm(newProps);

      var shouldUpdate = false;

      Object.entries(meta).forEach(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
            k = _ref5[0],
            v = _ref5[1];

        if (typeof v === 'function') {
          delete meta[k];
        }
        if (_this5.props[k] !== v && k !== 'defaultProperties') {
          shouldUpdate = true;
        }
      });
      if (shouldUpdate || this.firstTime) {
        this.firstTime = false;
        form.connector.setMeta(function (chain) {
          return chain.assign(meta);
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          form = _props2.form,
          noValidate = _props2.noValidate,
          className = _props2.className,
          children = _props2.children,
          action = _props2.action,
          handleSubmit = _props2.handleSubmit,
          preValidation = _props2.preValidation,
          onSuccess = _props2.onSuccess,
          onFailure = _props2.onFailure,
          onSubmit = _props2.onSubmit,
          rest = _objectWithoutProperties(_props2, ['form', 'noValidate', 'className', 'children', 'action', 'handleSubmit', 'preValidation', 'onSuccess', 'onFailure', 'onSubmit']);

      Object.entries(rest).forEach(function (_ref6) {
        var _ref7 = _slicedToArray(_ref6, 2),
            k = _ref7[0],
            v = _ref7[1];

        if (typeof v !== 'function') delete rest[k];
      });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'form',
        _extends({ noValidate: noValidate, className: className }, rest, {
          onSubmit: onSubmit || this.submit }),
        children
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_49__;

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TextInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FloatLabelTextInput; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enhanceInput__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Field__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_styled_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_components__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_startlibs_lib_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_polished__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_polished___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_polished__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp2;

var _templateObject = _taggedTemplateLiteral(['\n  bottom: 8px;\n  right: 0.6rem;\n  left: auto;\n  top: auto;\n'], ['\n  bottom: 8px;\n  right: 0.6rem;\n  left: auto;\n  top: auto;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  width: 100%;\n  font-size: 14px;\n  border: 1px solid ', ';\n  border-radius: 2px;\n  outline: 0;\n  outline: none;\n  color: ', ';\n  background: white;\n  position: relative;\n  height: 3rem;\n  padding: 0 0.7rem;\n  overflow: auto;\n\n  ::-webkit-input-placeholder {\n    color: rgba(0,0,0,0.3);\n  }\n  ::-moz-placeholder {\n    color: rgba(0,0,0,0.3);\n  }\n  :-moz-placeholder {\n    color: rgba(0,0,0,0.3);\n  }\n  :-ms-input-placeholder {\n    color: rgba(0,0,0,0.3);\n  }\n  ', '\n  ::-ms-clear { //Clear IE pseudo-buttons\n    display: none;\n  }\n  ', '\n  ', '\n  ', '\n'], ['\n  width: 100%;\n  font-size: 14px;\n  border: 1px solid ', ';\n  border-radius: 2px;\n  outline: 0;\n  outline: none;\n  color: ', ';\n  background: white;\n  position: relative;\n  height: 3rem;\n  padding: 0 0.7rem;\n  overflow: auto;\n\n  ::-webkit-input-placeholder {\n    color: rgba(0,0,0,0.3);\n  }\n  ::-moz-placeholder {\n    color: rgba(0,0,0,0.3);\n  }\n  :-moz-placeholder {\n    color: rgba(0,0,0,0.3);\n  }\n  :-ms-input-placeholder {\n    color: rgba(0,0,0,0.3);\n  }\n  ', '\n  ::-ms-clear { //Clear IE pseudo-buttons\n    display: none;\n  }\n  ', '\n  ', '\n  ', '\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    :focus {\n      border-color: ', ';\n      box-shadow: 0px 0px 0px 2px rgba(0,0,0,0.1);\n    }\n    ', '\n  '], ['\n    :focus {\n      border-color: ', ';\n      box-shadow: 0px 0px 0px 2px rgba(0,0,0,0.1);\n    }\n    ', '\n  ']),
    _templateObject4 = _taggedTemplateLiteral(['\n      border-color: ', ' !important;\n    '], ['\n      border-color: ', ' !important;\n    ']),
    _templateObject5 = _taggedTemplateLiteral(['\n    background-color: rgba(0,0,0,0.5);\n    border: 1px solid rgba(244,244,244,0.5);\n    color: #FFF;\n    font-size: 36px;\n    height: 4.5rem;\n  '], ['\n    background-color: rgba(0,0,0,0.5);\n    border: 1px solid rgba(244,244,244,0.5);\n    color: #FFF;\n    font-size: 36px;\n    height: 4.5rem;\n  ']),
    _templateObject6 = _taggedTemplateLiteral(['\n    padding-right: 2.25rem;\n    background: rgba(0,0,0,0.2);\n  '], ['\n    padding-right: 2.25rem;\n    background: rgba(0,0,0,0.2);\n  ']),
    _templateObject7 = _taggedTemplateLiteral(['\n  resize: none;\n  min-height: 9rem;\n  padding: .7rem;\n  display: block;\n  ', '\n'], ['\n  resize: none;\n  min-height: 9rem;\n  padding: .7rem;\n  display: block;\n  ', '\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  display: flex;\n  border-radius: 2px;\n  position: relative;\n  :before {\n    position: absolute;\n    border-radius: 2px;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    z-index: 2;\n    pointer-events: none;\n  }\n  ', '\n  ', '\n'], ['\n  display: flex;\n  border-radius: 2px;\n  position: relative;\n  :before {\n    position: absolute;\n    border-radius: 2px;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    z-index: 2;\n    pointer-events: none;\n  }\n  ', '\n  ', '\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n    box-shadow: 0px 0px 0px 2px rgba(0,0,0,0.1);\n    :before {\n      content: \'\';\n      border: 1px solid ', ';\n    }\n  '], ['\n    box-shadow: 0px 0px 0px 2px rgba(0,0,0,0.1);\n    :before {\n      content: \'\';\n      border: 1px solid ', ';\n    }\n  ']),
    _templateObject10 = _taggedTemplateLiteral(['\n    :before {\n      content: \'\';\n      border: 1px solid ', ';\n    }\n  '], ['\n    :before {\n      content: \'\';\n      border: 1px solid ', ';\n    }\n  ']),
    _templateObject11 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  padding: 0 0.7rem;\n  z-index: 1;\n  background-color: ', ';\n  border: 1px solid ', ';\n  cursor: text;\n'], ['\n  display: flex;\n  align-items: center;\n  padding: 0 0.7rem;\n  z-index: 1;\n  background-color: ', ';\n  border: 1px solid ', ';\n  cursor: text;\n']),
    _templateObject12 = _taggedTemplateLiteral(['\n  border-top-left-radius: 2px;\n  border-bottom-left-radius: 2px;\n  margin-right: -2px;\n'], ['\n  border-top-left-radius: 2px;\n  border-bottom-left-radius: 2px;\n  margin-right: -2px;\n']),
    _templateObject13 = _taggedTemplateLiteral(['\n  border-top-right-radius: 2px;\n  border-bottom-right-radius: 2px;\n  margin-left: -2px;\n'], ['\n  border-top-right-radius: 2px;\n  border-bottom-right-radius: 2px;\n  margin-left: -2px;\n']),
    _templateObject14 = _taggedTemplateLiteral(['\n  position: absolute;\n  outline: none;\n  bottom: 0;\n  font-size: 21px;\n  line-height: 3rem;\n  right: 0;\n  width: 2rem;\n  pointer-events: none;\n  color: ', ';\n'], ['\n  position: absolute;\n  outline: none;\n  bottom: 0;\n  font-size: 21px;\n  line-height: 3rem;\n  right: 0;\n  width: 2rem;\n  pointer-events: none;\n  color: ', ';\n']),
    _templateObject15 = _taggedTemplateLiteral(['\n    input {\n      height: 5rem;\n      box-shadow: 0 1px 4px rgba(0,0,0,.2);\n      border-radius: 4px;\n      font-size: 16px;\n      font-weight: 400;\n      padding: 16px 1rem 0;\n    }\n    ', ' {\n      position: absolute;\n      top: 1.5rem;\n      left: 1rem;\n      font-size: 20px;\n      font-weight: normal;\n      transition: all .2s ease;\n      color: rgba(0,0,0,.2);\n      pointer-events: none;\n      z-index: 1;\n      ', '\n    }\n  '], ['\n    input {\n      height: 5rem;\n      box-shadow: 0 1px 4px rgba(0,0,0,.2);\n      border-radius: 4px;\n      font-size: 16px;\n      font-weight: 400;\n      padding: 16px 1rem 0;\n    }\n    ', ' {\n      position: absolute;\n      top: 1.5rem;\n      left: 1rem;\n      font-size: 20px;\n      font-weight: normal;\n      transition: all .2s ease;\n      color: rgba(0,0,0,.2);\n      pointer-events: none;\n      z-index: 1;\n      ', '\n    }\n  ']);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }











var InputLoading = __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_components__["Loading"].extend(_templateObject);

var Input = __WEBPACK_IMPORTED_MODULE_3_styled_components___default.a.input(_templateObject2, __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib__["getColor"]('gray210'), __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib__["getColor"]('gray60'), function (props) {
  return !props.hasTextBox && __WEBPACK_IMPORTED_MODULE_3_styled_components__["css"](_templateObject3, __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib__["getColor"]('gray180'), function (props) {
    return props.hasErrors && __WEBPACK_IMPORTED_MODULE_3_styled_components__["css"](_templateObject4, __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib__["getColor"]('alert'));
  });
}, function (props) {
  return props.onImage && __WEBPACK_IMPORTED_MODULE_3_styled_components__["css"](_templateObject5);
}, function (props) {
  return props.locked && __WEBPACK_IMPORTED_MODULE_3_styled_components__["css"](_templateObject6);
}, __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib__["customTheme"]("TextInput"));

var TextArea = Input.withComponent('textarea').extend(_templateObject7, function (props) {
  return props.autoResize ? 'overflow:hidden;' : 'overflow:auto;';
});

var InputWithTextBox = __WEBPACK_IMPORTED_MODULE_3_styled_components___default.a.div(_templateObject8, function (props) {
  return props.focused && __WEBPACK_IMPORTED_MODULE_3_styled_components__["css"](_templateObject9, __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib__["getColor"]('gray180'));
}, function (props) {
  return props.hasErrors && __WEBPACK_IMPORTED_MODULE_3_styled_components__["css"](_templateObject10, __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib__["getColor"]('alert'));
});
var TextBox = __WEBPACK_IMPORTED_MODULE_3_styled_components___default.a.span(_templateObject11, function (props) {
  return __WEBPACK_IMPORTED_MODULE_6_polished__["darken"](0.075, __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib__["getColor"]('gray240')(props));
}, __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib__["getColor"]('gray210'));
var TextBoxBefore = __WEBPACK_IMPORTED_MODULE_3_styled_components___default.a(TextBox)(_templateObject12);
var TextBoxAfter = __WEBPACK_IMPORTED_MODULE_3_styled_components___default.a(TextBox)(_templateObject13);

var InputIcon = __WEBPACK_IMPORTED_MODULE_4_startlibs_lib_components__["Icon"].extend(_templateObject14, __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib__["getColor"]('gray150'));

var TextInput = __WEBPACK_IMPORTED_MODULE_1__enhanceInput__["a" /* enhanceInput */](_class = (_temp2 = _class2 = function (_React$Component) {
  _inherits(TextInput, _React$Component);

  function TextInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TextInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TextInput.__proto__ || Object.getPrototypeOf(TextInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = { focused: false }, _this.focusInput = function () {
      return _this.input.focus();
    }, _this.onFocus = function (e) {
      _this.setState({ focused: true });
      _this.props.onFocus && _this.props.onFocus(e);
    }, _this.onBlur = function (e) {
      _this.setState({ focused: false });
      _this.props.onBlur && _this.props.onBlur(e);
    }, _this.setRef = function (el) {
      _this.input = el;
      _this.props.setRef && _this.props.setRef(el);
    }, _this.handleChange = function (e) {
      var _this$props = _this.props,
          setValue = _this$props.setValue,
          constraint = _this$props.constraint,
          autoResize = _this$props.autoResize,
          value = _this$props.value;

      if (autoResize) {
        _this.input.style.height = 'auto';
        _this.input.style.height = _this.input.scrollHeight + 'px';
      }
      var target = e.target;
      _this.lastSelection = target.selectionEnd;
      if (constraint) {
        setValue(_this.validateConstraint(target.value, constraint, value), _this.input);
      } else {
        setValue(target.value, _this.input);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TextInput, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      // Todo disabled
      var _props = this.props,
          value = _props.value,
          FieldType = _props.FieldType,
          withoutField = _props.withoutField,
          fieldClassName = _props.fieldClassName,
          showValue = _props.showValue,
          autoFocus = _props.autoFocus,
          isLoading = _props.isLoading,
          inline = _props.inline,
          textarea = _props.textarea,
          label = _props.label,
          helpText = _props.helpText,
          descText = _props.descText,
          onImage = _props.onImage,
          mandatory = _props.mandatory,
          setValue = _props.setValue,
          setValueFromEventTarget = _props.setValueFromEventTarget,
          constraint = _props.constraint,
          hasErrors = _props.hasErrors,
          locked = _props.locked,
          rest = _objectWithoutProperties(_props, ['value', 'FieldType', 'withoutField', 'fieldClassName', 'showValue', 'autoFocus', 'isLoading', 'inline', 'textarea', 'label', 'helpText', 'descText', 'onImage', 'mandatory', 'setValue', 'setValueFromEventTarget', 'constraint', 'hasErrors', 'locked']);

      var focused = this.state.focused;

      var InputTag = textarea ? TextArea : Input;
      var WithTextBox = function WithTextBox(input) {
        if (_this2.props.textBoxBefore) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            InputWithTextBox,
            { focused: focused, hasErrors: hasErrors, onClick: _this2.focusInput },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              TextBoxBefore,
              null,
              _this2.props.textBoxBefore
            ),
            input
          );
        } else if (_this2.props.textBoxAfter) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            InputWithTextBox,
            { focused: focused, hasErrors: hasErrors, onClick: _this2.focusInput },
            input,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              TextBoxAfter,
              null,
              _this2.props.textBoxAfter
            )
          );
        } else {
          return input;
        }
      };
      var input = WithTextBox(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputTag, _extends({}, rest, {
        locked: locked,
        autoFocus: !__WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib__["isTouchDevice"]() && autoFocus,
        hasErrors: hasErrors,
        onImage: onImage,
        innerRef: this.setRef,
        value: showValue(value),
        onChange: this.handleChange,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        hasTextBox: this.props.textBoxBefore || this.textBoxAfter
      })));

      return withoutField ? input : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        FieldType,
        { className: fieldClassName, value: value, focused: focused, mandatory: mandatory, onImage: onImage,
          descText: descText, helpText: helpText, label: label, labelClick: this.focusInput },
        isLoading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputLoading, { absolute: true, size: 20 }),
        input,
        locked && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputIcon, { icon: 'lock' })
      );
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.lastSelection === 1 && this.props.constraint === 'capitalize') {
        this.input.setSelectionRange(this.lastSelection, this.lastSelection);
      }
    }
  }, {
    key: 'validateConstraint',
    value: function validateConstraint(value, constraint, oldValue) {
      var newValue = '';
      if (value === this.lastValue || this.lastValue && value.length < this.lastValue.length) {
        this.lastValue = value;
        return value;
      }
      if (constraint === 'price') {
        value = value.replace('.', ',').replace(/[^0-9,]/g, '');
        var number = parseFloat(value.replace(',', '.'));
        var commas = value.split(',');
        var fixedNumber = number.toFixed(2);
        newValue = !!commas[0] && commas.length === 2 && parseFloat(fixedNumber) === number && fixedNumber.split('.')[1].indexOf(commas[1]) === 0 ? value : __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib__["digitsToPattern"]('>3?????#,##', value);
      } else if (constraint === 'capitalize') {
        // v = "R$ "+(parseInt(v.replace(/[^1-9]*([0-9]*)(,?)([0-9]{0,3}).*/,"$1$3") || 0)/100).toFixed(2).replace(".",",");
        newValue = value.replace(/^[a-z]/, function (e) {
          return e.toUpperCase();
        });
      } else if (constraint === 'number' || constraint === 'hour' || constraint === 'hour-int') {
        newValue = value.replace(/\D/g, '');
        if (newValue !== '') {
          newValue = window.parseInt(newValue, 10);
          if (constraint !== 'number') {
            if ((newValue + '').length > 4 || newValue > 2399) {
              newValue = oldValue;
            } else {
              var resultHour = __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib__["intToHour"](newValue, false);
              var val = resultHour.replace(/\D/g, '');
              var result = isNaN(parseInt(val, 10)) ? undefined : parseInt(val, 10);
              newValue = constraint === 'hour-int' ? result : resultHour;
            }
          }
        }
      } else if (constraint === 'cpf') {
        newValue = __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib__["digitsToPattern"]('###.###.###-##', value);
      } else if (constraint === 'cnpj') {
        newValue = __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib__["digitsToPattern"]('##.###.###/####-##', value);
      } else {
        newValue = __WEBPACK_IMPORTED_MODULE_5_startlibs_lib_lib__["digitsToPattern"](constraint, value);
      }
      this.lastValue = newValue + '';
      return newValue;
    }
  }]);

  return TextInput;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class2.defaultProps = {
  value: '',
  setValue: null,
  showValue: function showValue(v) {
    return v === null ? '' : v;
  },
  type: 'text',
  FieldType: __WEBPACK_IMPORTED_MODULE_2__Field__["a" /* Field */]
}, _temp2)) || _class;

TextInput.Input = Input;
TextInput.TextArea = TextArea;
/* unused harmony default export */ var _unused_webpack_default_export = (TextInput);

var FloatingFieldType = __WEBPACK_IMPORTED_MODULE_3_styled_components___default.a(__WEBPACK_IMPORTED_MODULE_2__Field__["a" /* Field */])(_templateObject15, __WEBPACK_IMPORTED_MODULE_2__Field__["a" /* Field */].Label, function (props) {
  return (props.value || props.focused) && '\n        top: 12px;\n        font-size: 14px;\n        color: rgba(0,0,0,.4);\n      ';
});
var FloatLabelTextInput = function FloatLabelTextInput(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TextInput, _extends({}, props, { FieldType: FloatingFieldType }));
};

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FileInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return withFormImageInput; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_styled_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_actionHelpers__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_icepath__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_icepath___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_icepath__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    z-index: 1;\n    cursor: pointer;\n    opacity: 0;\n    position: absolute;\n    top: 0;\n    right: 0;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n    ::-webkit-file-upload-button {\n      visibility: hidden;\n    }\n    ::file-upload-button {\n      visibility: hidden;\n    }\n  '], ['\n    z-index: 1;\n    cursor: pointer;\n    opacity: 0;\n    position: absolute;\n    top: 0;\n    right: 0;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n    ::-webkit-file-upload-button {\n      visibility: hidden;\n    }\n    ::file-upload-button {\n      visibility: hidden;\n    }\n  ']);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }






var FileInput = __WEBPACK_IMPORTED_MODULE_1_styled_components___default.a.input.attrs({ type: 'file' })(_templateObject);

var withFormImageInput = function withFormImageInput(preValidate, uploadFetcher) {
  var getValues = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (properties, props) {
    return { image: __WEBPACK_IMPORTED_MODULE_3_icepath__["ice"].get(properties, props.path) };
  };
  var setValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (chain, _ref, props) {
    var image = _ref.image;
    return chain.set(props.path, image);
  };
  return function (InnerComponent) {
    return function (_React$PureComponent) {
      _inherits(_class2, _React$PureComponent);

      function _class2() {
        var _ref2;

        var _temp, _this, _ret;

        _classCallCheck(this, _class2);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = _class2.__proto__ || Object.getPrototypeOf(_class2)).call.apply(_ref2, [this].concat(args))), _this), _this.handleFile = function (file, eventTarget) {
          var _this$props$form = _this.props.form,
              properties = _this$props$form.properties,
              connector = _this$props$form.connector,
              meta = _this$props$form.meta;

          var path = _this.props.path ? [].concat(_this.props.path) : [];
          if (preValidate) {
            var validation = preValidate(file);
            if (validation) {
              connector.setErrors(_defineProperty({}, path.join('.'), validation));
              return;
            }
          }
          var oldUploadStatus = __WEBPACK_IMPORTED_MODULE_3_icepath__["ice"].get(meta, path.concat('uploadStatus'));
          var oldValues = getValues(properties, _this.props);

          var objectUrl = URL.createObjectURL(file);
          var image = document.createElement('img');
          image.onload = function () {
            var imageWidth = image.naturalWidth,
                imageHeight = image.naturalHeight;

            var newValues = { image: file, filename: file.name, imageWidth: imageWidth, imageHeight: imageHeight };

            connector.setValues(function (chain) {
              return setValues(chain, newValues, _this.props);
            });
            connector.setMeta(function (chain) {
              return chain.update(['submittingImage'], function (v) {
                return v ? v + 1 : 1;
              }).set(path.concat('uploadStatus'), 'loading').set(path.concat('uploadingImage'), URL.createObjectURL(file));
            });
            uploadFetcher(file, _this.props).then(function (_ref3) {
              var image = _ref3.image,
                  uploadStatus = _ref3.uploadStatus;

              if (getValues(connector.getFormProperties(), _this.props).image !== file) {
                connector.setMeta(function (chain) {
                  return chain.update(['submittingImage'], function (v) {
                    return v - 1;
                  });
                });
                return;
              }
              connector.clearErrors();
              connector.setValues(function (chain) {
                return setValues(chain, _extends({}, newValues, { image: image }), _this.props);
              }, false);
              connector.setMeta(function (chain) {
                return chain.update(['submittingImage'], function (v) {
                  return v - 1;
                }).set(path.concat('uploadStatus'), uploadStatus).unset(path.concat('uploadingImage'));
              });
              _this.props.onSuccess && _this.props.onSuccess({ image: image, uploadStatus: uploadStatus, imageWidth: imageWidth, imageHeight: imageHeight });
            }).catch(function () {
              if (getValues(connector.getFormProperties(), _this.props).image !== file) {
                connector.setMeta(function (chain) {
                  return chain.update(['submittingImage'], function (v) {
                    return v - 1;
                  });
                });
                return;
              }
              connector.setErrors(_defineProperty({}, path.join('.'), [__WEBPACK_IMPORTED_MODULE_2__reducers_actionHelpers__["b" /* AJAX_ERROR */]]));
              connector.setValues(function (chain) {
                return setValues(chain, oldValues, _this.props);
              }, false);
              connector.setMeta(function (chain) {
                return chain.update(['submittingImage'], function (v) {
                  return v - 1;
                }).set(path.concat('uploadStatus'), oldUploadStatus).unset(path.concat('uploadingImage'));
              });
            });
            if (eventTarget && eventTarget.parentNode && typeof eventTarget.parentNode.click === 'function') eventTarget.parentNode.click();
          };
          image.src = objectUrl;
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }

      _createClass(_class2, [{
        key: 'render',
        value: function render() {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InnerComponent, _extends({}, this.props, { handleFile: this.handleFile }));
        }
      }]);

      return _class2;
    }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);
  };
};

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SimpleCheckbox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enhanceInput__ = __webpack_require__(12);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var SimpleCheckbox = __WEBPACK_IMPORTED_MODULE_1__enhanceInput__["a" /* enhanceInput */](_class = function (_React$PureComponent) {
  _inherits(SimpleCheckbox, _React$PureComponent);

  function SimpleCheckbox() {
    _classCallCheck(this, SimpleCheckbox);

    return _possibleConstructorReturn(this, (SimpleCheckbox.__proto__ || Object.getPrototypeOf(SimpleCheckbox)).apply(this, arguments));
  }

  _createClass(SimpleCheckbox, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          value = _props.value,
          hasErrors = _props.hasErrors,
          toggle = _props.toggle,
          disabled = _props.disabled,
          label = _props.label,
          className = _props.className,
          tabIndex = _props.tabIndex;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'label',
        { disabled: disabled, className: className + (hasErrors ? ' hasErrors' : ''), 'data-drag': 'false' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { disabled: disabled, type: 'checkbox', onChange: toggle, checked: !!value, tabIndex: tabIndex }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          label
        )
      );
    }
  }]);

  return SimpleCheckbox;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent)) || _class;

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SimpleRadiobox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_styled_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enhanceInput__ = __webpack_require__(12);
var _templateObject = _taggedTemplateLiteral(['\n\n    \n'], ['\n\n    \n']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }





var SimpleRadiobox = __WEBPACK_IMPORTED_MODULE_2__enhanceInput__["a" /* enhanceInput */](__WEBPACK_IMPORTED_MODULE_1_styled_components___default.a(function (_ref) {
  var className = _ref.className,
      setFromField = _ref.setFromField,
      disabled = _ref.disabled,
      name = _ref.name,
      tabIndex = _ref.tabIndex,
      icon = _ref.icon,
      value = _ref.value,
      label = _ref.label,
      fieldValue = _ref.fieldValue,
      stringifyValue = _ref.stringifyValue;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'label',
    { disabled: disabled, className: className, 'data-drag': 'false' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { disabled: disabled, type: 'radio', value: stringifyValue ? stringifyValue(fieldValue) : fieldValue, name: name, tabIndex: tabIndex,
      onChange: setFromField, checked: stringifyValue ? stringifyValue(value) === stringifyValue(fieldValue) : value === fieldValue }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      null,
      label
    )
  );
})(_templateObject));

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Combobox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Field__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enhanceInput__ = __webpack_require__(12);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Combobox = (_dec = __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs__["withPopupToggles"]('contextMenu'), _dec(_class = __WEBPACK_IMPORTED_MODULE_4__enhanceInput__["a" /* enhanceInput */](_class = (_temp2 = _class2 = function (_React$Component) {
  _inherits(Combobox, _React$Component);

  function Combobox() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Combobox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Combobox.__proto__ || Object.getPrototypeOf(Combobox)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.toggleCombobox = function (e) {
      _this.setState({ hoverValue: undefined });
      _this.props.contextMenu.toggle(e);
    }, _this.getLabel = function (item) {
      return item ? _this.props.getLabel(item) : item;
    }, _this.recenterScroll = function () {
      if (_this.listElement.getBoundingClientRect().bottom > window.innerHeight) {
        var scrollContainer = _this.props.scrollContainer(_this.container);
        scrollContainer.scrollTop = _this.listElement.getBoundingClientRect().bottom + scrollContainer.scrollTop - window.innerHeight;
      }
      if (_this.selectedElement) {
        _this.listElement.scrollTop = _this.selectedElement.offsetTop + _this.selectedElement.offsetHeight / 2 - _this.listElement.offsetHeight / 2;
      }
      _this.shouldRecenter = false;
    }, _this.Option = Option, _this.setHover = function (hoverValue) {
      return _this.setState({ hoverValue: hoverValue });
    }, _this.keyDown = function (e) {
      e.stopPropagation();
      if ((e.key === 'Escape' || e.key === 'Tab') && _this.props.contextMenu.isOpen) {
        _this.toggleCombobox();
      }
      if (['ArrowUp', 'ArrowDown', ' ', 'Enter'].indexOf(e.key) < 0) {
        return;
      }
      e.preventDefault();
      if (_this.props.contextMenu.isOpen) {
        if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
          var oldValue = _this.state.hoverValue !== undefined ? _this.state.hoverValue : _this.props.value;
          var options = _this.props.options;
          var newIndex = Math.min(Math.max((options.indexOf(oldValue) + options.length + (e.key === 'ArrowUp' ? -1 : 1)) % options.length, 0), options.length - 1);
          _this.setState({ hoverValue: options[newIndex] }, function () {
            if (_this.selectedElement.offsetTop < _this.listElement.scrollTop) {
              _this.listElement.scrollTop = _this.selectedElement.offsetTop;
            } else if (_this.selectedElement.offsetTop + _this.selectedElement.offsetHeight > _this.listElement.scrollTop + _this.listElement.offsetHeight) {
              _this.listElement.scrollTop = _this.selectedElement.offsetTop + _this.selectedElement.offsetHeight - _this.listElement.offsetHeight;
            }
          });
        } else {
          if (_this.state.hoverValue) _this.props.setValue(_this.state.hoverValue);
          _this.toggleCombobox();
        }
      } else {
        _this.toggleCombobox();
      }
    }, _this.setRef = function (el) {
      _this.selectedElement = el;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Combobox, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (!this.props.contextMenu.isOpen && newProps.contextMenu.isOpen) {
        this.shouldRecenter = true;
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.shouldRecenter) {
        this.recenterScroll();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          value = _props.value,
          contextMenu = _props.contextMenu,
          tabIndex = _props.tabIndex,
          setValue = _props.setValue,
          disabled = _props.disabled,
          options = _props.options,
          placeholder = _props.placeholder;
      var _props2 = this.props,
          label = _props2.label,
          mandatory = _props2.mandatory,
          fieldClassName = _props2.fieldClassName,
          descText = _props2.descText,
          helpText = _props2.helpText;

      var withPlaceholder = !value && value !== 0 && placeholder;
      var hoverValue = this.state.hoverValue;

      var combobox = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { ref: function ref(el) {
            return _this2.container = el;
          }, onKeyDown: this.keyDown,
          className: 'combobox-input' + (contextMenu.isOpen ? ' expanded' : '') + (withPlaceholder ? ' with-placeholder' : '') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { className: 'fake-input', disabled: disabled, tabIndex: tabIndex,
            onClick: this.toggleCombobox },
          withPlaceholder ? placeholder : this.getLabel(value)
        ),
        contextMenu.isOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'ul',
          { ref: function ref(e) {
              return _this2.listElement = e;
            }, className: 'context-menu combobox-menu visible styled-combobox' },
          options.map(function (option) {
            var label = _this2.getLabel(option);
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(_this2.Option, {
              key: label,
              option: option,
              checked: hoverValue !== undefined ? option === hoverValue : option === value,
              label: label,
              setValue: setValue,
              setRef: _this2.setRef,
              onHover: _this2.setHover
            });
          })
        )
      );
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__Field__["a" /* Field */],
        { className: fieldClassName, mandatory: mandatory, descText: descText, helpText: helpText, label: label,
          labelClick: this.toggleCombobox },
        combobox
      );
    }
  }]);

  return Combobox;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class2.defaultProps = {
  scrollContainer: function scrollContainer(el) {
    return el.closest('.dialog-container') || document.body;
  },
  getLabel: function getLabel(item) {
    return item;
  }
}, _temp2)) || _class) || _class);

var Option = function (_React$Component2) {
  _inherits(Option, _React$Component2);

  function Option() {
    var _ref2;

    var _temp3, _this3, _ret2;

    _classCallCheck(this, Option);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp3 = (_this3 = _possibleConstructorReturn(this, (_ref2 = Option.__proto__ || Object.getPrototypeOf(Option)).call.apply(_ref2, [this].concat(args))), _this3), _this3.setRef = function (el) {
      if (_this3.props.checked) _this3.props.setRef(el);
    }, _this3.setValue = function () {
      _this3.props.setValue(_this3.props.option);
    }, _this3.setHover = function () {
      return _this3.props.onHover(_this3.props.option);
    }, _temp3), _possibleConstructorReturn(_this3, _ret2);
  } // eslint-disable-line no-unused-vars


  _createClass(Option, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref3) {
      var checked = _ref3.checked;

      if (!this.props.checked && checked) {
        this.props.setRef(__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          label = _props3.label,
          checked = _props3.checked;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        {
          className: checked ? 'hover-item' : '',
          onMouseOver: this.setHover,
          ref: this.setRef,
          onClick: this.setValue
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          null,
          label
        )
      );
    }
  }]);

  return Option;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StyledIconRadioBox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IconRadioBox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_styled_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Icon__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__enhanceInput__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_styled__ = __webpack_require__(8);
var _templateObject = _taggedTemplateLiteral(['\n  flex-grow: 1;\n  padding: 0.5rem;\n  min-height: 3rem;\n  align-content: center;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  -ms-flex-positive: 1;\n  display: -ms-flexbox;\n  -ms-flex-line-pack: center;\n  -ms-flex-align: center;\n  -ms-flex-pack: center;\n  -ms-flex-direction: column;\n\n  background-color: transparent;\n  border-top: 1px solid ', ';\n  text-align: center;\n'], ['\n  flex-grow: 1;\n  padding: 0.5rem;\n  min-height: 3rem;\n  align-content: center;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  -ms-flex-positive: 1;\n  display: -ms-flexbox;\n  -ms-flex-line-pack: center;\n  -ms-flex-align: center;\n  -ms-flex-pack: center;\n  -ms-flex-direction: column;\n\n  background-color: transparent;\n  border-top: 1px solid ', ';\n  text-align: center;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid ', ';\n  color: ', ';\n  border-radius: 5px;\n  background-color: #fff;\n  cursor: pointer;\n\n  ', '\n\n  ', ' {\n    font-size: 100px;\n    line-height: 72px;\n    margin: 0.5rem auto;\n    text-align: center;\n  }\n\n  input {\n    opacity: 0;\n    position: absolute;\n    left: -20000000px;\n  }\n\n  input:focus ~ ', '::after {\n   content: \'\';\n    position: absolute;\n    top: -4px;\n    right: -4px;\n    left: -4px;\n    bottom: -4px;\n    border-radius: 7px;\n    border: 2px solid rgba(0, 0, 0, 0.2);\n  }\n\n  ', '\n'], ['\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid ', ';\n  color: ', ';\n  border-radius: 5px;\n  background-color: #fff;\n  cursor: pointer;\n\n  ', '\n\n  ', ' {\n    font-size: 100px;\n    line-height: 72px;\n    margin: 0.5rem auto;\n    text-align: center;\n  }\n\n  input {\n    opacity: 0;\n    position: absolute;\n    left: -20000000px;\n  }\n\n  input:focus ~ ', '::after {\n   content: \'\';\n    position: absolute;\n    top: -4px;\n    right: -4px;\n    left: -4px;\n    bottom: -4px;\n    border-radius: 7px;\n    border: 2px solid rgba(0, 0, 0, 0.2);\n  }\n\n  ', '\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    border-color: ', ';\n    color: ', ';\n    ', ' {\n      background-color: ', ';\n      border-top-color: ', ';\n      color:#fff;\n    }\n  '], ['\n    border-color: ', ';\n    color: ', ';\n    ', ' {\n      background-color: ', ';\n      border-top-color: ', ';\n      color:#fff;\n    }\n  ']),
    _templateObject4 = _taggedTemplateLiteral(['\n    :hover ', ' {\n      background-color: ', ';\n      color: #fff;\n    }\n  '], ['\n    :hover ', ' {\n      background-color: ', ';\n      color: #fff;\n    }\n  ']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }








var Text = __WEBPACK_IMPORTED_MODULE_1_styled_components___default.a.div(_templateObject, __WEBPACK_IMPORTED_MODULE_4__lib_styled__["b" /* getColor */]('gray150'));

var StyledIconRadioBox = __WEBPACK_IMPORTED_MODULE_1_styled_components___default.a(function (_ref) {
  var className = _ref.className,
      setFromField = _ref.setFromField,
      name = _ref.name,
      tabIndex = _ref.tabIndex,
      icon = _ref.icon,
      value = _ref.value,
      label = _ref.label,
      fieldValue = _ref.fieldValue;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'label',
    { className: className },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'radio', value: fieldValue, name: name, tabIndex: tabIndex,
      onChange: setFromField, checked: value === fieldValue }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Icon__["a" /* Icon */], { icon: icon }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Text,
      null,
      label
    )
  );
})(_templateObject2, __WEBPACK_IMPORTED_MODULE_4__lib_styled__["b" /* getColor */]('gray150'), __WEBPACK_IMPORTED_MODULE_4__lib_styled__["b" /* getColor */]('gray150'), function (props) {
  return props.value === props.fieldValue ? __WEBPACK_IMPORTED_MODULE_1_styled_components__["css"](_templateObject3, __WEBPACK_IMPORTED_MODULE_4__lib_styled__["b" /* getColor */]('main'), __WEBPACK_IMPORTED_MODULE_4__lib_styled__["b" /* getColor */]('main'), Text, __WEBPACK_IMPORTED_MODULE_4__lib_styled__["b" /* getColor */]('main'), __WEBPACK_IMPORTED_MODULE_4__lib_styled__["b" /* getColor */]('main')) : __WEBPACK_IMPORTED_MODULE_1_styled_components__["css"](_templateObject4, Text, __WEBPACK_IMPORTED_MODULE_4__lib_styled__["b" /* getColor */]('gray150'));
}, __WEBPACK_IMPORTED_MODULE_2__Icon__["a" /* Icon */], __WEBPACK_IMPORTED_MODULE_2__Icon__["a" /* Icon */], __WEBPACK_IMPORTED_MODULE_4__lib_styled__["a" /* customTheme */]("IconRadioBox"));

var IconRadioBox = __WEBPACK_IMPORTED_MODULE_3__enhanceInput__["a" /* enhanceInput */](StyledIconRadioBox);

IconRadioBox.Text = Text;

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AutoComplete; });
/* unused harmony export AutoCompleteTextbox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_icepath__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_icepath___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_icepath__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enhanceInput__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Errors__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_startlibs_lib_lib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_startlibs_lib_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_startlibs_lib_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_styled_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Field__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_polished__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_polished___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_polished__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp, _initialiseProps, _class3, _temp3;

var _templateObject = _taggedTemplateLiteral(['\n  bottom: 8px;\n  right: 0.6rem;\n  left: auto;\n  top: auto;\n'], ['\n  bottom: 8px;\n  right: 0.6rem;\n  left: auto;\n  top: auto;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  width: 100%;\n  font-size: 14px;\n  border: 1px solid ', ';\n  border-radius: 2px;\n  color: ', ';\n  cursor: text;\n  background: white;\n  position: relative;\n  outline: 0;\n  outline: none;\n  min-height: 3rem;\n  line-height: 34px;\n  padding: 0 0.7rem;\n  ', '\n  ', '\n  ', '\n'], ['\n  width: 100%;\n  font-size: 14px;\n  border: 1px solid ', ';\n  border-radius: 2px;\n  color: ', ';\n  cursor: text;\n  background: white;\n  position: relative;\n  outline: 0;\n  outline: none;\n  min-height: 3rem;\n  line-height: 34px;\n  padding: 0 0.7rem;\n  ', '\n  ', '\n  ', '\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    border-color: ', ' !important;\n  '], ['\n    border-color: ', ' !important;\n  ']),
    _templateObject4 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  pointer-events: none;\n  color: rgba(0,0,0,0.4);\n'], ['\n  position: absolute;\n  top: 0;\n  pointer-events: none;\n  color: rgba(0,0,0,0.4);\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  display: inline-block;\n  outline: 0;\n  outline: none;\n  padding: 0 1px;\n  line-height: 130%;\n'], ['\n  display: inline-block;\n  outline: 0;\n  outline: none;\n  padding: 0 1px;\n  line-height: 130%;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  background-color: rgb(230,230,230);\n  padding: 2px 2rem 4px 0.75rem;\n  border-radius: 12px;\n  font-size: 13px;\n  position: relative;\n  margin: 0.4rem 0.7rem 0 -0.25rem;\n  vertical-align: 1px;\n  white-space: nowrap;\n  display: inline-block;\n  cursor: default;\n  line-height: normal;\n'], ['\n  background-color: rgb(230,230,230);\n  padding: 2px 2rem 4px 0.75rem;\n  border-radius: 12px;\n  font-size: 13px;\n  position: relative;\n  margin: 0.4rem 0.7rem 0 -0.25rem;\n  vertical-align: 1px;\n  white-space: nowrap;\n  display: inline-block;\n  cursor: default;\n  line-height: normal;\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  display: inline-block;\n  position: absolute;\n  top: 50%;\n  line-height: 20px;\n  transform: translateY(-50%);\n  right: 2px;\n  font-size: 14px;\n  text-align: center;\n  cursor: pointer;\n  color: ', ';\n  :hover {\n    background-color: ', ';\n    color: ', ';\n  }\n'], ['\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  display: inline-block;\n  position: absolute;\n  top: 50%;\n  line-height: 20px;\n  transform: translateY(-50%);\n  right: 2px;\n  font-size: 14px;\n  text-align: center;\n  cursor: pointer;\n  color: ', ';\n  :hover {\n    background-color: ', ';\n    color: ', ';\n  }\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.4);\n  ', ' {\n      > * {\n        padding: 11px;\n      }\n  }\n'], ['\n  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.4);\n  ', ' {\n      > * {\n        padding: 11px;\n      }\n  }\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n  ', ' {\n    background: transparent;\n    border: none;\n    color: ', ';\n    padding: 0;\n    margin-top: 0.5rem;\n    font-weight: 600;\n    ', ' {\n      display: none;\n    }\n  }\n'], ['\n  ', ' {\n    background: transparent;\n    border: none;\n    color: ', ';\n    padding: 0;\n    margin-top: 0.5rem;\n    font-weight: 600;\n    ', ' {\n      display: none;\n    }\n  }\n']);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }












var InputLoading = __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__["Loading"].extend(_templateObject);
var AutoCompleteInput = __WEBPACK_IMPORTED_MODULE_7_styled_components___default.a.div(_templateObject2, __WEBPACK_IMPORTED_MODULE_6_startlibs_lib_lib__["getColor"]('gray210'), __WEBPACK_IMPORTED_MODULE_6_startlibs_lib_lib__["getColor"]('gray60'), function (props) {
  return props.focused && '\n    border-color: ' + __WEBPACK_IMPORTED_MODULE_6_startlibs_lib_lib__["getColor"]('gray180') + ';\n    box-shadow: 0px 0px 0px 2px rgba(0,0,0,0.075);\n  ';
}, function (props) {
  return props.hasErrors && __WEBPACK_IMPORTED_MODULE_7_styled_components__["css"](_templateObject3, __WEBPACK_IMPORTED_MODULE_6_startlibs_lib_lib__["getColor"]('alert'));
}, __WEBPACK_IMPORTED_MODULE_6_startlibs_lib_lib__["customTheme"]("TextInput"));

var AutoCompletePlaceholder = __WEBPACK_IMPORTED_MODULE_7_styled_components___default.a.span(_templateObject4);

var AutoCompleteTextboxDiv = __WEBPACK_IMPORTED_MODULE_7_styled_components___default.a.div(_templateObject5);
var AddedBox = __WEBPACK_IMPORTED_MODULE_7_styled_components___default.a.span(_templateObject6);
var RemoveIcon = __WEBPACK_IMPORTED_MODULE_7_styled_components___default.a(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__["Icon"])(_templateObject7, __WEBPACK_IMPORTED_MODULE_6_startlibs_lib_lib__["getColor"]('gray120'), __WEBPACK_IMPORTED_MODULE_6_startlibs_lib_lib__["getColor"]('gray210'), function (props) {
  return __WEBPACK_IMPORTED_MODULE_9_polished__["darken"](0.05, __WEBPACK_IMPORTED_MODULE_6_startlibs_lib_lib__["getColor"]('alert')(props));
});

var AutoCompleteMenu = __WEBPACK_IMPORTED_MODULE_7_styled_components___default.a(__WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__["ContextMenu"])(_templateObject8, __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__["ContextMenu"].ListItem);

var AutoCompleteError = __WEBPACK_IMPORTED_MODULE_7_styled_components___default.a(__WEBPACK_IMPORTED_MODULE_5__Errors__["a" /* Errors */])(_templateObject9, __WEBPACK_IMPORTED_MODULE_5__Errors__["a" /* Errors */].Item, __WEBPACK_IMPORTED_MODULE_6_startlibs_lib_lib__["getColor"]('alert'), __WEBPACK_IMPORTED_MODULE_5__Errors__["a" /* Errors */].CloseIcon);

var focusBeforeLast = function focusBeforeLast(e) {
  if (e.target && e.target !== e.currentTarget) return;
  var el = [].slice.call(e.currentTarget.querySelectorAll('div[contenteditable]')).slice(-1)[0];
  el.focus();
  if (!el.firstChild) {
    var node = document.createTextNode('');
    el.appendChild(node);
  }
  setSelectionRange(el.firstChild, el.textContent.length + 1);
};

var setSelectionRange = function setSelectionRange(input, selectionStart) {
  var selectionEnd = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  var range = document.createRange();
  var sel = window.getSelection();
  range.setStart(input, Math.max(selectionStart - 1, 0));
  sel.removeAllRanges();
  sel.addRange(range);
};

var AutoComplete = (_dec = __WEBPACK_IMPORTED_MODULE_2_startlibs_lib_hocs__["withToggles"]('autoCompleteBox', 'hoverIndex', 'isLoading'), __WEBPACK_IMPORTED_MODULE_4__enhanceInput__["a" /* enhanceInput */](_class = _dec(_class = (_temp = _class2 = function (_React$Component) {
  _inherits(AutoComplete, _React$Component);

  function AutoComplete(props) {
    _classCallCheck(this, AutoComplete);

    var _this = _possibleConstructorReturn(this, (AutoComplete.__proto__ || Object.getPrototypeOf(AutoComplete)).call(this, props));

    _initialiseProps.call(_this);

    _this.editables = [(props.value || []).length];
    _this.listSize = _this.editables[0];
    _this.state = { autoCompleteList: [] };
    return _this;
  }

  _createClass(AutoComplete, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(newProps) {
      if (this.props.value !== newProps.value) {
        this.refreshSuggestions(this.lastIsEditable() ? this.getValue().slice(-1)[0] : '');
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      var _this2 = this;

      var newValue = newProps.value || [];
      if (newValue.length !== this.listSize) {
        this.editables = this.editables.map(function (i) {
          return newValue.indexOf(_this2.getValue()[i]);
        }).filter(function (_) {
          return _ >= 0;
        });
        if (!this.editables.length) {
          this.editables = [newValue.length];
        }
        this.focusInput();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          AutoCompleteLi = _props.AutoCompleteLi,
          confirmIfNewKeys = _props.confirmIfNewKeys,
          deleteOnBackspace = _props.deleteOnBackspace,
          hoverIndex = _props.hoverIndex,
          placeholder = _props.placeholder,
          autoSelect = _props.autoSelect,
          hasErrors = _props.hasErrors,
          CompletedBox = _props.CompletedBox,
          EditableInput = _props.EditableInput,
          value = _props.value,
          getLabel = _props.getLabel,
          autoCompleteBox = _props.autoCompleteBox;
      var _props2 = this.props,
          withoutField = _props2.withoutField,
          fieldClassName = _props2.fieldClassName,
          mandatory = _props2.mandatory,
          descText = _props2.descText,
          helpText = _props2.helpText,
          label = _props2.label,
          isLoading = _props2.isLoading;

      var validValue = value || [''];
      var _state = this.state,
          autoCompleteList = _state.autoCompleteList,
          errors = _state.errors;

      var uniqueKeyLabel = {};
      var getUniqueKey = function getUniqueKey(label) {
        var uid = uniqueKeyLabel[label] = (uniqueKeyLabel[label] || 0) + 1;
        return label + uid;
      };
      var valueWithEditable = this.lastIsEditable() ? validValue : validValue.concat('');
      var input = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          AutoCompleteInput,
          {
            innerRef: function innerRef(el) {
              return _this3.el = el;
            },
            onFocus: autoCompleteBox.open,
            hasErrors: hasErrors || errors && errors.length,
            onBlur: this.onBlur,
            onClick: focusBeforeLast,
            focused: autoCompleteBox.isOpen
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            '\u200B'
          ),
          valueWithEditable.map(function (v, i) {
            return _this3.editables.indexOf(i) >= 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AutoCompleteTextbox, {
              value: v,
              index: i,
              deleteOnBackspace: deleteOnBackspace,
              EditableInput: EditableInput,
              key: '$$editable$$' + i,
              onChange: _this3.onChange,
              remove: _this3.remove,
              confirm: _this3.confirm,
              confirmIfNew: _this3.confirmIfNew,
              confirmIfNewKeys: confirmIfNewKeys
            }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CompletedBox, {
              key: getLabel(v),
              label: getLabel(v),
              value: v,
              remove: function remove() {
                return _this3.remove(i);
              }
            });
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            '\u200B'
          ),
          (!value || !value.join('')) && placeholder && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            AutoCompletePlaceholder,
            null,
            placeholder
          ),
          autoCompleteBox.isOpen !== false && !this.state.errors && autoCompleteList.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            AutoCompleteMenu,
            {
              hoverIndex: hoverIndex.isOpen,
              autoHover: autoSelect,
              onHover: hoverIndex.open,
              my: 'top left',
              at: 'bottom left',
              fill: true
            },
            autoCompleteList.map(function (value) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AutoCompleteLi, {
                key: getUniqueKey(getLabel(value)),
                label: getLabel(value),
                onMouseDown: function onMouseDown(e) {
                  return e.preventDefault();
                },
                onClick: function onClick() {
                  return _this3.addValue(value);
                }
              });
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AutoCompleteError, { errors: this.state.errors })
      );
      return withoutField ? input : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__Field__["a" /* Field */],
        { className: fieldClassName, value: value, mandatory: mandatory,
          descText: descText, helpText: helpText, label: label, labelClick: this.focusInput },
        isLoading.isOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputLoading, { absolute: true, size: 20 }),
        input
      );
    }
  }]);

  return AutoComplete;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class2.defaultProps = {
  AutoCompleteLi: __WEBPACK_IMPORTED_MODULE_3_startlibs_lib_components__["Li"],
  CompletedBox: function CompletedBox(_ref) {
    var label = _ref.label,
        remove = _ref.remove,
        value = _ref.value;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      AddedBox,
      { title: label },
      label,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RemoveIcon, { icon: 'x', onClick: remove })
    );
  },
  EditableInput: function EditableInput(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AutoCompleteTextboxDiv, props);
  },
  getLabel: function getLabel(v) {
    return v;
  },
  minQueryLength: 3,
  ignoreCase: true,
  fetchLimit: 6,
  deleteOnBackspace: true,
  validation: function validation(value) {
    return { success: value.trim() };
  }
}, _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.queries = [];

  this.confirmIfNew = function (index, newValue) {
    _this4.refreshSuggestions(newValue, true).then(function (list) {
      if (!list.length) {
        _this4.confirm(index, newValue);
      } else {
        _this4.onChange(index, newValue);
      }
    });
  };

  this.confirm = function (index, newValue) {
    var hoverIndex = _this4.props.hoverIndex.isOpen;
    if (_this4.state.autoCompleteList.length && hoverIndex >= 0) {
      _this4.addValue(_this4.state.autoCompleteList[hoverIndex]);
    } else {
      _this4.confirmValue(index, newValue);
    }
  };

  this.confirmValue = function (index, newValue, fromBlur) {
    if (!newValue) {
      return;
    }
    var suggestedValue = _this4.suggestionsLabelMapCache[_this4.ignoreCase(newValue || "").trim()];
    if (suggestedValue) {
      _this4.addValue(suggestedValue, fromBlur);
      return;
    }

    var _props$validation = _this4.props.validation(newValue),
        success = _props$validation.success,
        errors = _props$validation.errors;

    if (errors) {
      _this4.setState({
        errors: errors.map(function (v) {
          return [{
            value: v,
            remove: function remove() {
              return _this4.setState({ errors: _this4.state.errors.filter(function (_) {
                  return _.value !== v;
                }) });
            }
          }];
        })
      });
    } else {
      _this4.addValue(success, fromBlur);
    }
  };

  this.onChange = function (index, value) {
    _this4.setState({ errors: null });
    var newValue = __WEBPACK_IMPORTED_MODULE_1_icepath__["ice"].set(_this4.getValue(), [index], value);
    _this4.listSize = newValue.length;
    _this4.props.setValue(newValue);
  };

  this.suggestionsFetchCache = {};
  this.suggestionsLabelMapCache = {};
  this.lastSuggestionQuery = "";

  this.ignoreCase = function (s) {
    return _this4.props.ignoreCase ? (s || "").toLowerCase() : s;
  };

  this.fetchSuggestions = function (s) {
    var lastQuery = _this4.lastSuggestionQuery;
    _this4.lastSuggestionQuery = s;
    if (_this4.suggestionsFetchCache[s]) {
      return _this4.suggestionsFetchCache[s];
    } else {
      var lastFetch = _this4.suggestionsFetchCache[_this4.ignoreCase(lastQuery)];
      if (s.indexOf(_this4.ignoreCase(lastQuery)) >= 0 && lastFetch && lastFetch.length < _this4.props.fetchLimit) {
        return _this4.suggestionsFetchCache[s] = lastFetch.map(_this4.props.getLabel).filter(function (_) {
          return _this4.ignoreCase(_).indexOf(_this4.ignoreCase(s)) >= 0;
        }).map(function (_) {
          return _this4.suggestionsLabelMapCache[_this4.ignoreCase(_)];
        });
      } else {
        var fetch = Promise.resolve(_this4.props.fetchSuggestions(s));
        fetch.then(function (list) {
          _this4.suggestionsFetchCache[_this4.ignoreCase(s)] = list;
          list.forEach(function (suggestion) {
            return _this4.suggestionsLabelMapCache[_this4.ignoreCase(_this4.props.getLabel(suggestion))] = _this4.suggestionsLabelMapCache[_this4.ignoreCase(_this4.props.getLabel(suggestion))] || suggestion;
          });
        });
        return fetch;
      }
    }
  };

  this.refreshSuggestions = function (value, justFetch) {
    if (value.length >= _this4.props.minQueryLength) {
      _this4.queries = [value];
      _this4.props.isLoading.open();
      return Promise.resolve(_this4.fetchSuggestions(_this4.ignoreCase(value))).then(function (list) {
        _this4.props.isLoading.close();
        var noRepeatedList = list.filter(function (v) {
          return !_this4.getValue().find(function (_) {
            return _this4.props.getLabel(v) === _this4.props.getLabel(_);
          });
        });
        if (justFetch) {
          return noRepeatedList;
        }
        var index = _this4.queries.indexOf(value);
        if (index >= 0) {
          _this4.queries = _this4.queries.slice(index + 1);
          if (!_this4.props.autoSelect) {
            _this4.props.hoverIndex.open(-1);
          } else {
            _this4.props.hoverIndex.open(0);
          }
          _this4.setState({ autoCompleteList: noRepeatedList });
        }
      });
    } else {
      _this4.props.hoverIndex.open(-1);
      _this4.setState({ autoCompleteList: [] });
      return Promise.resolve([]);
    }
  };

  this.addValue = function (value, fromBlur) {
    var index = _this4.lastIsEditable() ? _this4.getValue().length - 1 : _this4.getValue().length;
    _this4.editables = _this4.editables.filter(function (_) {
      return _ !== index;
    }).concat([index + 1]);
    _this4.props.setValue(__WEBPACK_IMPORTED_MODULE_1_icepath__["ice"].set(_this4.getValue(), index, value));
    if (!fromBlur) {
      _this4.focusInput();
    }
  };

  this.remove = function (index) {
    _this4.editables = _this4.editables.map(function (_) {
      return _ >= index ? _ - 1 : 1;
    });
    var newList = __WEBPACK_IMPORTED_MODULE_1_icepath__["ice"].unset(_this4.getValue(), index);
    _this4.listSize = newList.length;
    _this4.props.setValue(newList);
    _this4.focusInput();
  };

  this.onBlur = function () {
    _this4.props.autoCompleteBox.close();
    var v = _this4.getValue().slice(-1)[0];
    if (_this4.lastIsEditable()) {
      var _props$validation2 = _this4.props.validation(v),
          errors = _props$validation2.errors;

      if (_this4.props.autoSelect && _this4.state.autoCompleteList.length === 1 && errors) {
        _this4.addValue(_this4.state.autoCompleteList[0], true);
      } else {
        _this4.confirmValue(_this4.getValue().length - 1, v, true);
      }
    }
  };

  this.getValue = function () {
    return _this4.props.value || [];
  };

  this.lastIsEditable = function () {
    return Math.max.apply(0, _this4.editables) === (_this4.props.value || ['']).length - 1;
  };

  this.focusInput = function () {
    return setTimeout(function () {
      return focusBeforeLast({ currentTarget: _this4.el });
    }, 1);
  };
}, _temp)) || _class) || _class);

AutoComplete.AddedBox = AddedBox;
AutoComplete.RemoveIcon = RemoveIcon;
AutoComplete.AutoCompleteTextboxDiv = AutoCompleteTextboxDiv;

var cleanText = function cleanText(text) {
  var clean = text.replace('\u200B', '').replace(/\n/g, ' ').replace(/\s+/g, ' ');
  return clean.trim() ? clean : '';
};

var AutoCompleteTextbox = (_temp3 = _class3 = function (_React$Component2) {
  _inherits(AutoCompleteTextbox, _React$Component2);

  function AutoCompleteTextbox() {
    var _ref2;

    var _temp2, _this5, _ret;

    _classCallCheck(this, AutoCompleteTextbox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp2 = (_this5 = _possibleConstructorReturn(this, (_ref2 = AutoCompleteTextbox.__proto__ || Object.getPrototypeOf(AutoCompleteTextbox)).call.apply(_ref2, [this].concat(args))), _this5), _this5.deletePrev = function () {
      return _this5.props.index > 0 && _this5.props.remove(_this5.props.index - 1);
    }, _this5.onKeyDown = function (e) {
      var range = window.getSelection().getRangeAt(0);
      if (_this5.props.confirmIfNewKeys.indexOf(e.key) >= 0) {
        e.preventDefault();
        _this5.props.confirmIfNew(_this5.props.index, cleanText(__WEBPACK_IMPORTED_MODULE_1_icepath__["ice"].splice(range.startContainer.textContent.split(''), range.startOffset, 0, '\uFFFD').join('').trim().replace('\uFFFD', e.key)));
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        e.stopPropagation();
      } else if (_this5.props.confirmKeys.indexOf(e.key) >= 0) {
        e.preventDefault();
        if (_this5.props.value) {
          e.stopPropagation();
          _this5.props.confirm(_this5.props.index, _this5.props.value);
        }
      } else if (e.key === 'Backspace' && _this5.props.deleteOnBackspace && (range.collapsed && range.startOffset === 0 || e.target.textContent === '\u200B')) {
        e.preventDefault();
        _this5.deletePrev();
      }
    }, _this5.onChange = function (evt) {
      _this5.props.onChange(_this5.props.index, cleanText(evt.target.innerText));
    }, _this5.onPaste = function (ev) {
      ev.preventDefault();
      var text = ev.clipboardData.getData('text');
      document.execCommand('insertText', false, text);
    }, _temp2), _possibleConstructorReturn(_this5, _ret);
  }

  _createClass(AutoCompleteTextbox, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var _this6 = this;

      var event = new Event('portalReposition');
      setTimeout(function () {
        return window.dispatchEvent(event);
      }, 1);
      if (this.el.innerHTML === "<br>" || !this.el.innerHTML) {
        this.el.innerHTML = '\u200B';
      }
      return nextProps.value !== cleanText(this.el.innerText) || !!Object.keys(nextProps).find(function (k) {
        return nextProps[k] !== _this6.props[k];
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(oldProps) {
      if (this.props.value.slice(-1) === ' ' && /\S/.test(this.el.textContent.slice(-1))) {
        // does not have blank space as last
        this.el.innerHTML = this.props.value.replace(/\s/, '&nbsp;');
      }
      if (this.props.value !== oldProps.value && document.activeElement === this.el) {
        setSelectionRange(this.el.firstChild || this.el, this.el.textContent.length + 1);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      var _props3 = this.props,
          value = _props3.value,
          confirmKeys = _props3.confirmKeys,
          index = _props3.index,
          EditableInput = _props3.EditableInput,
          confirmIfNewKeys = _props3.confirmIfNewKeys,
          confirmIfNew = _props3.confirmIfNew,
          confirm = _props3.confirm,
          remove = _props3.remove,
          rest = _objectWithoutProperties(_props3, ['value', 'confirmKeys', 'index', 'EditableInput', 'confirmIfNewKeys', 'confirmIfNew', 'confirm', 'remove']);

      var valueOrBlank = value || '\u200B';
      var props = _extends({
        innerRef: function innerRef(ref) {
          return _this7.el = ref;
        },
        contentEditable: true,
        onInput: this.onChange,
        onKeyDown: this.onKeyDown,
        onPaste: this.onPaste,
        value: value,
        index: index,
        dangerouslySetInnerHTML: { __html: valueOrBlank.replace(/\s/, '&nbsp;') }
      }, rest);
      return typeof EditableInput === "function" ? EditableInput(props) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EditableInput, props);
    }
  }]);

  return AutoCompleteTextbox;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class3.defaultProps = {
  confirmIfNewKeys: [],
  confirmKeys: ['Enter', ',']
}, _temp3);

/***/ })
/******/ ]);
});
//# sourceMappingURL=form.js.map


//////////////////
// WEBPACK FOOTER
// ./~/startlibs/lib/form.js
// module id = 7
// module chunks = 4